import cn from "classnames";
import React from "react";
import { TooltipIcon } from "../components/TooltipIcon";

export const PricesMobile = ({
     tariffs,
     freq,
     total,
     totalBase = 0,
     priceMonth,
     activeCount,
     activeFreq,
     setActiveCount,
     setActiveFreq,
     activePeriod,
     setActivePeriod,
     tariffPrice,
     freqPrice,
     addonItems = [],
     selectedAddons = new Set(),
     setSelectedAddons,
 }) => {
    const activeTariff = tariffs.find((el) => el.count_products === activeCount);
    
    const addonsDeltaPerMonth = Array.from(selectedAddons).reduce((sum, key) => {
        const found = addonItems.find(a => a.key === key);
        if (key === 'training') {
            return sum;
        }
        return sum + (found ? found.priceDelta : 0);
    }, 0);
    const trainingPrice = selectedAddons.has('training') ? (addonItems.find(a => a.key === 'training')?.priceDelta || 0) : 0;
    const addonsTotalForPeriod = addonsDeltaPerMonth * activePeriod + trainingPrice;
    const idMonth = activePeriod;
    return (
        <div className="lg:hidden flex flex-col pl-6">
            <div className="flex items-center pr-6">
        <span className="block text-[#D9D9D9] text-xs leading-[18px] font-bold mr-4">
          ШАГ 1
        </span>
                <div className="grow bg-[#2B3135] h-[1px]" />
            </div>
            <span className="block mt-1 text-xs leading-[18px] text-[#919BA0]">
        Выберите кол-во товаров
        <br />
        для мониторинга цен
      </span>
            <div className="relative">
                <div
                    className="absolute right-0 w-[35px] h-[70px]"
                    style={{
                        background:
                            "linear-gradient(267deg, #1B2126 16.37%, rgba(27, 33, 38, 0.00) 96.93%)",
                    }}
                />
                <div className="mt-3 overflow-x-auto mobile-tariffs-block">
                    <div className="flex space-x-2 pb-6">
                        {tariffs.map((tariff) => {
                            const { name, price, count_products } = tariff;
                            const resultName = name.split(" ");
                            if (Number.isInteger(+resultName[0])) {
                                resultName[0] = (+resultName[0]).toLocaleString("ru");
                            }
                            return (
                                <div
                                    className={cn(
                                        "border border-[rgb(255,255,255,0.07)] py-2 px-3 rounded-[8px]",
                                        {
                                            "border-white": count_products === activeCount,
                                        }
                                    )}
                                    key={count_products + name}
                                    onClick={() => {
                                        if (count_products === 10) {
                                            setActivePeriod(1);
                                            setActiveFreq(1);
                                        }
                                        setActiveCount(count_products);
                                    }}
                                >
                  <span className="block text-white text-[12px] leading-[15px] whitespace-nowrap">
                    {resultName.join(" ")}
                  </span>
                                    <span className="block text-[#FFE8AE] text-[10px] leading-[16px] pt-[3px]">
                    {price === -1
                        ? "Персонально"
                        : activeCount === count_products
                            ? price === 0
                                ? "0 ₽"
                                : ""
                            : `${price.toLocaleString("ru")} ₽`}
                  </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="flex items-center pr-6">
        <span className="block text-[#D9D9D9] text-xs leading-[18px] font-bold mr-4">
          ШАГ 2
        </span>
                <div className="grow bg-[#2B3135] h-[1px]" />
            </div>
            <span className="block mt-1 text-xs leading-[18px] text-[#919BA0]">
        Выберите как часто необходимо <br /> обновлять цены
      </span>
            <div className="relative">
                <div
                    className="absolute right-0 w-[35px] h-[70px]"
                    style={{
                        background:
                            "linear-gradient(267deg, #1B2126 16.37%, rgba(27, 33, 38, 0.00) 96.93%)",
                    }}
                />
                <div className="mt-3 overflow-x-auto mobile-tariffs-block">
                    <div className="flex space-x-2 pb-6">
                        {activeTariff &&
                            activeTariff.frequencies.map((freq) => {
                                const { name, price, frequency } = freq;
                                return (
                                    <div
                                        className={cn(
                                            "border border-[rgb(255,255,255,0.07)] py-2 px-3 rounded-[8px]",
                                            {
                                                "border-white": frequency === activeFreq,
                                            }
                                        )}
                                        key={frequency + name}
                                        onClick={() => setActiveFreq(frequency)}
                                    >
                    <span className="block text-white text-[12px] leading-[15px] whitespace-nowrap">
                      {name}
                    </span>
                                        <span className="block text-[#FFE8AE] text-[10px] leading-[16px] pt-[3px]">
                      {price === -1
                          ? "Персонально"
                          : activeFreq === frequency
                              ? price === 0
                                  ? "0 ₽"
                                  : ""
                              : `${price.toLocaleString("ru")} ₽`}
                    </span>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
            <div className="flex items-center pr-6">
        <span className="block text-[#D9D9D9] text-xs leading-[18px] font-bold mr-4">
          ШАГ 3
        </span>
                <div className="grow bg-[#2B3135] h-[1px]" />
            </div>
            <span className="block mt-1 text-xs leading-[18px] text-[#919BA0]">
        Дополнительные опции
      </span>
            <div className="mt-3 pr-6 space-y-2">
                {addonItems.map((item) => {
                    const isOn = selectedAddons.has(item.key);
                    const toggle = () => {
                        if (setSelectedAddons) {
                            setSelectedAddons(prev => {
                                const next = new Set(prev);
                                if (next.has(item.key)) {
                                    next.delete(item.key);
                                } else {
                                    next.add(item.key);
                                }
                                return next;
                            });
                        }
                    };
                    return (
                        <div
                            key={`addon-${item.key}`}
                            onClick={toggle}
                            className={cn(
                                "flex items-center justify-between w-full px-3 py-2 rounded-[8px] border cursor-pointer",
                                {
                                    "bg-[#2B3135] border-white": isOn,
                                    "border-[rgb(255,255,255,0.07)]": !isOn
                                }
                            )}
                        >
                            <div className="flex items-center gap-2 flex-1 min-w-0">
                                <div className="min-w-0">
                                    <span className="block text-white text-[12px] leading-[15px]">{item.title}</span>
                                    <span className="block text-[#FFE8AE] text-[10px] leading-[16px] pt-[3px]">
                                        {item.priceDelta.toLocaleString('ru')} ₽
                                    </span>
                                </div>
                                {item.tooltipText && (
                                    <TooltipIcon text={item.tooltipText} />
                                )}
                            </div>
                            <span className={cn("w-[36px] h-[20px] rounded-full p-[2px] transition-colors flex-shrink-0", isOn ? "bg-[#9DCF4E]" : "bg-[#2B3135]")}>
                                <span className={cn("block w-[16px] h-[16px] bg-white rounded-full transition-transform", isOn ? "translate-x-[16px]" : "translate-x-0")}/>
                            </span>
                        </div>
                    );
                })}
            </div>
            <div className="flex items-center pr-6 mt-6">
        <span className="block text-[#D9D9D9] text-xs leading-[18px] font-bold mr-4">
          ШАГ 4
        </span>
                <div className="grow bg-[#2B3135] h-[1px]" />
            </div>
            <span className="block mt-1 text-xs leading-[18px] text-[#919BA0]">
        Выберите кол-во месяцев <br /> действия сервиса
      </span>
            <div className="relative">
                <div
                    className="absolute right-0 w-[35px] h-[70px]"
                    style={{
                        background:
                            "linear-gradient(267deg, #1B2126 16.37%, rgba(27, 33, 38, 0.00) 96.93%)",
                    }}
                />
                <div className="mt-3 overflow-x-auto mobile-tariffs-block">
                    <div className="flex space-x-2 pb-6">
                        {activeTariff &&
                            activeTariff.frequencies.find(
                                (el) => el.frequency === activeFreq
                            ) &&
                            activeTariff.frequencies
                                .find((el) => el.frequency === activeFreq)
                                .periods.filter(
                                (el, index) => !(activeCount === 10 && index !== 0)
                            )
                                .map((period, index) => {
                                    const { name, id } = period;
                                    const splittedName = name.split(" ");
                                    splittedName[1] = splittedName[1].slice(0, 3);
                                    return (
                                        <div
                                            className={cn(
                                                "border border-[rgb(255,255,255,0.07)] py-2 px-3 rounded-[8px]",
                                                {
                                                    "border-white": id === activePeriod,
                                                }
                                            )}
                                            key={id + name}
                                            onClick={() => setActivePeriod(id)}
                                        >
                      <span className="block text-white text-[12px] leading-[15px] whitespace-nowrap">
                        {splittedName.join(" ")}
                      </span>
                                            {index !== 0 && (
                                                <span className="block text-[#FF7B74] text-[10px] leading-[16px] pt-[3px] whitespace-nowrap">{`Скидка ${
                                                    10 + (index - 1) * 5
                                                } %`}</span>
                                            )}
                                            {/*{index !== 0 && <span className="block text-[#FF7B74] text-[10px] leading-[16px]">{`${10 + (index - 1) * 5} %`}</span>}*/}
                                        </div>
                                    );
                                })}
                    </div>
                </div>
            </div>
            <div className="flex items-center pr-6">
        <span className="block text-[#D9D9D9] text-xs leading-[18px] font-bold mr-4">
          ШАГ 5
        </span>
                <div className="grow bg-[#2B3135] h-[1px]" />
            </div>
            <span className="block mt-1 text-xs leading-[18px] text-[#919BA0]">
        Осталось оплатить и начать
        <br /> пользоваться!
      </span>
            <div className="mt-3 pr-6">
                {/* Line 1: Мониторинг */}
                <span
                    className={cn(
                        "block mb-2 flex justify-between w-full items-baseline text-[#9DCF4E] text-base font-normal leading-[23px]",
                        {
                            '-tracking-[2px]': activeCount === 1001
                        }
                    )}
                >
                    {activeCount === 1001 ?
                        <span>Мониторинг: Персонально</span>
                        : (() => {
                            const priceMonthBase = totalBase && activePeriod ? (totalBase / activePeriod) : 0;
                            return <div className="flex justify-between items-baseline w-full">
                                <span className="text-base">Мониторинг в месяц</span>
                                <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                                <span className="text-base">{priceMonthBase.toLocaleString('ru')} ₽</span>
                            </div>;
                        })()
                    }
                </span>
                {/* Line 2: Доп. опции */}
                <span
                    className={cn(
                        "block mb-2 flex justify-between w-full items-baseline text-[#9DCF4E] text-base font-normal leading-[23px]",
                        {
                            '-tracking-[2px]': activeCount === 1001
                        }
                    )}
                >
                    {activeCount === 1001 ?
                        <span>Доп. опции: Персонально</span>
                        : <div className="flex justify-between items-baseline w-full">
                            <span className="text-base">Доп. опции</span>
                            <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                            <span className="text-base">{addonsTotalForPeriod.toLocaleString('ru')} ₽</span>
                        </div>
                    }
                </span>
                {/* Line 3: Всего за {idMonth} месяц */}
                <span
                    className={cn(
                        "block flex justify-between w-full items-baseline text-[#9DCF4E] text-[24px] font-normal leading-[30px]",
                        {
                            '-tracking-[2px]': activeCount === 1001,
                            '!text-[20px]':
                                (total && total.toLocaleString('ru').length > 5) ||
                                (total && total >= 2000) ||
                                activeCount === 1001
                        }
                    )}
                >
                    {activeCount === 1001 ?
                        'Персонально'
                        :   <div className="flex justify-between items-baseline w-full">
                                <span className="text-base">Всего за {idMonth} {idMonth === 1 ? 'месяц' : idMonth < 5 ? 'месяца' : 'месяцев'}</span>
                                <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                                <span className="text-[24px]">{total.toLocaleString('ru')} ₽</span>
                            </div>
                    }
                </span>
            </div>
        </div>
    );
};
